export default {
  allowConnectToDB: true,
  allowedMobileOnly: true,
  overrideProportionalResize: true,
};
